/*import CryptoJS from "crypto-js";*/
import Cookies from 'universal-cookie';

const cookies = new Cookies();

/*var CryptoJS = require('crypto-js');*/

/* let myStorage = window.localStorage; */

/*let cryptoKey = '';

if (typeof window !== 'undefined' && typeof(Storage) !== "undefined") {
  if (!(cryptoKey = myStorage.getItem('userLocalIdentity'))) {
    cryptoKey = CryptoJS.enc.Hex.stringify(CryptoJS.lib.WordArray.random(16));
    myStorage.setItem('userLocalIdentity', cryptoKey);
  }
}*/

export const setLocalStorage = (key, storageValue, path='/') => {
  /*if (typeof window !== 'undefined' && typeof(Storage) !== "undefined") {
    var scipherText = JSON.stringify(storageValue);
    //scipherText = CryptoJS.AES.encrypt(scipherText, cryptoKey).toString();
    myStorage.setItem(key, scipherText);
  }*/
  if (key && storageValue) {
    var scipherText = JSON.stringify(storageValue);
    cookies.set(key, scipherText, { path: path });
  }
}

export const getLocalStorage = (key) => {
  /*if (typeof window !== 'undefined' && typeof(Storage) !== "undefined") {
    var originalText = myStorage.getItem(key);
    if (originalText !== null) {
      //var bytes = CryptoJS.AES.decrypt(originalText, cryptoKey);
      //originalText = bytes.toString(CryptoJS.enc.Utf8);
      return originalText ? JSON.parse(originalText) : false;
    } else {
      return false;
    }
  }*/
  let originalText = cookies.get(key);
  if (originalText !== null && originalText !== undefined) {
    return originalText ? (IsJsonString(originalText) ? JSON.parse(originalText) : originalText) : false;
    //return originalText || false;
  } else {
    return false;
  }
}

export const clearAllLocalStorage = (key) => {
  /*if (typeof window !== 'undefined' && typeof(Storage) !== "undefined") {
    myStorage.clear();
  }*/
  if (key) {
    cookies.remove(key, { path: '/' });
  }
}

export const deleteLocalStorage = (key) => {
  /*if (typeof window !== 'undefined' && typeof(Storage) !== "undefined") {
    myStorage.removeItem(key);
  }*/
  if (key) {
    cookies.remove(key, { path: '/' });
  }
}

export const checkIfExists = (key) => {
  /*if (typeof window !== 'undefined' && typeof(Storage) !== "undefined") {
    return myStorage.getItem(key);
  } else {
    return null;
  }*/
  return getLocalStorage(key);
}

function IsJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
